
// // import axios from "axios";
// // import { useEffect, useState, useMemo } from "react";
// // import { useNavigate } from "react-router-dom";
// // import ApiUrl from "./../Environment/ApiUrl";
// // import { useToast } from "../Toast/ToastContext";
// // import { jsPDF } from "jspdf";
// // import autoTable from "jspdf-autotable";
// // import * as XLSX from "xlsx";

// // function Stock() {
// //   const toast = useToast();
// //   const navigate = useNavigate();
// //   const [activeTab, setActiveTab] = useState("day-wise");
// //   const [currentPage, setCurrentPage] = useState(1);
// //   const [itemsPerPage, setItemsPerPage] = useState(10);
// //   const [showAllItems, setShowAllItems] = useState(false);
// //   const [searchTerm, setSearchTerm] = useState("");
// //   const [responseData, setResponseData] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [deleteLoading, setDeleteLoading] = useState(false);
// //   const [showDeleteModal, setShowDeleteModal] = useState(false);
// //   const [itemToDelete, setItemToDelete] = useState(null);
// //   const [stocktotal, setStockTotal] = useState({});
// //   const [stocktotalinventory, setStockTotalInventory] = useState({});
// //   const [notifications, setNotifications] = useState([]);
// //   const [showNotificationModal, setShowNotificationModal] = useState(false);
// //   const [selectedStockId, setSelectedStockId] = useState(null);
// //   const [actionType, setActionType] = useState("");
// //   const [isSubmitting, setIsSubmitting] = useState(false);

// //   // Handle tab click
// //   const handleTabClick = (tab) => {
// //     setActiveTab(tab);
// //     setCurrentPage(1);
// //     setSearchTerm("");
// //   };

// //   // Navigate to add stock pages
// //   const handleAddStock = () => {
// //     navigate("/add-stock");
// //   };

// //   const handleAddPersonalStock = () => {
// //     navigate("/personal-stock");
// //   };

// //   // Fetch data based on active tab
// //   useEffect(() => {
// //     fetchData();
// //   }, [activeTab]);

// //   const fetchData = async () => {
// //     try {
// //       setLoading(true);
// //       let url;
// //       if (activeTab === "day-wise") {
// //         const currentDate = "2025-06-20"; // Make dynamic if needed
// //         url = `${ApiUrl}/Api/stock.php/current-stock?date=${currentDate}`;
// //       } else {
// //         url = `${ApiUrl}/Api/stock.php`;
// //       }

// //       const response = await axios.get(url);
// //       console.log(`Response from ${activeTab}:`, response.data?.data);

// //       const data = Array.isArray(response.data?.data) ? response.data.data : [];
// //       setResponseData(data);

// //       setTimeout(() => {
// //         setLoading(false);
// //       }, 1000);
// //     } catch (error) {
// //       console.error("Error fetching data:", error.message);
// //       toast.error("Failed to fetch data", 3000, "topRight");
// //       setResponseData([]);
// //       setLoading(false);
// //     }
// //   };

// //   // Fetch stock totals
// //   const fetchDatastock = async () => {
// //     try {
// //       const response = await axios.get(`${ApiUrl}/Api/stock.php/stock_total`);
// //       setStockTotal(response.data?.data || {});
// //       console.log("Stock total response:", response.data.data);
// //     } catch (error) {
// //       console.error("Error fetching stock totals:", error.message);
// //     }
// //   };

// //   // Fetch stock inventory totals
// //   const fetchDatastockinventory = async () => {
// //     try {
// //       const response = await axios.get(`${ApiUrl}/Api/stock.php/metal-totals`);
// //       setStockTotalInventory(response.data?.data || {});
// //       console.log("Stock inventory response:", response.data.data);
// //     } catch (error) {
// //       console.error("Error fetching stock inventory:", error.message);
// //     }
// //   };

// //   // Fetch notifications
// //   const fetchNotifications = async () => {
// //     try {
// //       const response = await axios.get(`${ApiUrl}/Api/notification.php`);
// //       setNotifications(response.data?.data || []);
// //     } catch (error) {
// //       console.error("Error fetching notifications:", error.message);
// //       toast.error("Failed to fetch notifications", 3000, "topRight");
// //     }
// //   };

// //   // Check if a notification is accepted for the action
// //   const checkNotificationStatus = (stockId, buttonValue) => {
// //     const userId = localStorage.getItem("username");
// //     return notifications.some(
// //       (notif) =>
// //         notif.table_id === stockId.toString() &&
// //         notif.button_value === buttonValue &&
// //         notif.status === "accepted" &&
// //         notif.employe_id === userId &&
// //         notif.viewed === "false"
// //     );
// //   };

// //   // Check if a notification is pending
// //   const hasPendingNotification = (stockId, buttonValue) => {
// //     const userId = localStorage.getItem("username");
// //     return notifications.some(
// //       (notif) =>
// //         notif.table_id === stockId.toString() &&
// //         notif.button_value === buttonValue &&
// //         notif.status === "requested" &&
// //         notif.employe_id === userId &&
// //         notif.viewed === "false"
// //     );
// //   };

// //   // Open notification modal
// //   const openNotificationModal = (id, action) => {
// //     setSelectedStockId(id);
// //     setActionType(action);
// //     setShowNotificationModal(true);
// //   };

// //   // Close notification modal
// //   const closeNotificationModal = () => {
// //     setShowNotificationModal(false);
// //     setSelectedStockId(null);
// //     setActionType("");
// //     setIsSubmitting(false);
// //   };

// //   // Handle notification submission
// //   const handleNotificationSubmit = async (e) => {
// //     e.preventDefault();
// //     e.stopPropagation();

// //     if (isSubmitting) return;
// //     setIsSubmitting(true);

// //     if (hasPendingNotification(selectedStockId, actionType)) {
// //       toast.warn("A pending request for this action already exists!", 3000, "topRight");
// //       closeNotificationModal();
// //       return;
// //     }

// //     try {
// //       const userId = localStorage.getItem("username");
// //       const currentTime = new Date().toISOString().slice(0, 19).replace("T", " ");

// //       const formData = {
// //         table_name: "stock",
// //         table_id: selectedStockId,
// //         employe_id: userId || "",
// //         status: "requested",
// //         button_value: actionType,
// //         time: currentTime,
// //         viewed: "false",
// //         created_date: currentTime,
// //         updated_by: userId || "",
// //         updated_date: currentTime,
// //       };

// //       await axios.post(`${ApiUrl}/Api/notification.php`, formData, {
// //         headers: { "Content-Type": "application/json" },
// //       });

// //       toast.success(`${actionType} request sent successfully!`, 3000, "topRight");
// //       closeNotificationModal();
// //       fetchNotifications();
// //     } catch (error) {
// //       console.error("Error submitting notification:", error.message);
// //       toast.error("Error submitting notification. Please try again.", 3000, "topRight");
// //     } finally {
// //       setIsSubmitting(false);
// //     }
// //   };

// //   // Fetch data and notifications periodically
// //   useEffect(() => {
// //     fetchData();
// //     fetchDatastock();
// //     fetchDatastockinventory();
// //     fetchNotifications();
// //     const interval = setInterval(() => {
// //       fetchData();
// //       fetchNotifications();
// //     }, 5000);
// //     return () => clearInterval(interval);
// //   }, [activeTab]);

// //   // Filter data based on search term
// //   const filteredData = useMemo(() => {
// //     if (!Array.isArray(responseData)) return [];

// //     return responseData.filter((item) => {
// //       if (!item) return false;

// //       const searchMatch =
// //         searchTerm === "" ||
// //         (item.item &&
// //           item.item.toLowerCase().includes(searchTerm.toLowerCase())) ||
// //         (item.category &&
// //           item.category.toLowerCase().includes(searchTerm.toLowerCase()));

// //       return searchMatch;
// //     });
// //   }, [responseData, searchTerm]);

// //   // Calculate pagination values
// //   const totalItems = filteredData.length;
// //   const totalPages = showAllItems ? 1 : Math.ceil(totalItems / itemsPerPage);

// //   // Get current items for pagination
// //   const currentItems = showAllItems
// //     ? filteredData
// //     : filteredData.slice(
// //         (currentPage - 1) * itemsPerPage,
// //         currentPage * itemsPerPage
// //       );

// //   // Pagination handlers
// //   const handlePageChange = (page) => {
// //     if (page < 1 || page > totalPages) return;
// //     setCurrentPage(page);
// //   };

// //   const handleItemsPerPageChange = (e) => {
// //     const value = e.target.value;
// //     if (value === "All") {
// //       setShowAllItems(true);
// //       setCurrentPage(1);
// //     } else {
// //       setShowAllItems(false);
// //       setItemsPerPage(Number(value));
// //       setCurrentPage(1);
// //     }
// //   };

// //   // Export Functions
// //   const handlePrint = () => {
// //     let tableHtml = "";
// //     let title = "";

// //     if (activeTab === "day-wise") {
// //       title = "Day-Wise Stock Report";
// //       tableHtml = `
// //         <h2>${title}</h2>
// //         <table style="width:100%; border-collapse: collapse;">
// //           <thead>
// //             <tr style="background-color: #f2f2f2;">
// //               <th style="border: 1px solid #ddd; padding: 8px;">S.No</th>
// //               <th style="border: 1px solid #ddd; padding: 8px;">Category</th>
// //               <th style="border: 1px solid #ddd; padding: 8px;">Item</th>
// //               <th style="border: 1px solid #ddd; padding: 8px;">Weight</th>
// //               <th style="border: 1px solid #ddd; padding: 8px;">Total Quantity</th>
// //               <th style="border: 1px solid #ddd; padding: 8px;">Sold Quantity</th>
// //               <th style="border: 1px solid #ddd; padding: 8px;">Available Quantity</th>
// //               <th style="border: 1px solid #ddd; padding: 8px;">Stock IDs</th>
// //             </tr>
// //           </thead>
// //           <tbody>
// //             ${filteredData
// //               .map(
// //                 (item, index) => {
// //                   const userId = localStorage.getItem("username");
// //                   const notification = notifications.find(
// //                     (notif) =>
// //                       notif.table_id === item.id?.toString() &&
// //                       notif.employe_id === userId &&
// //                       notif.viewed === "false"
// //                   );
// //                   let rowClass = "";
// //                   if (notification) {
// //                     switch (notification.status) {
// //                       case "accepted":
// //                         rowClass = "background-color: #e2e3e5;";
// //                         break;
// //                       case "rejected":
// //                         rowClass = "background-color: #f8d7da;";
// //                         break;
// //                       case "requested":
// //                         rowClass = "background-color: #cff4fc;";
// //                         break;
// //                     }
// //                   }
// //                   return `
// //                     <tr style="${rowClass}">
// //                       <td style="border: 1px solid #ddd; padding: 8px;">${index + 1}</td>
// //                       <td style="border: 1px solid #ddd; padding: 8px;">${item?.category || ""}</td>
// //                       <td style="border: 1px solid #ddd; padding: 8px;">${item.item || ""}</td>
// //                       <td style="border: 1px solid #ddd; padding: 8px;">${item.weight || ""}</td>
// //                       <td style="border: 1px solid #ddd; padding: 8px;">${item.total_quantity || ""}</td>
// //                       <td style="border: 1px solid #ddd; padding: 8px;">${item.sold_quantity || ""}</td>
// //                       <td style="border: 1px solid #ddd; padding: 8px;">${item.avaliable_quantity || ""}</td>
// //                       <td style="border: 1px solid #ddd; padding: 8px;">${
// //                         item.stock_ids && item.stock_ids.length > 0
// //                           ? item.stock_ids.join(", ")
// //                           : "No IDs"
// //                       }</td>
// //                     </tr>
// //                   `;
// //                 }
// //               )
// //               .join("")}
// //           </tbody>
// //         </table>
// //       `;
// //     } else {
// //       title = "Stock Inventory Report";
// //       tableHtml = `
// //         <h2>${title}</h2>
// //         <table style="width:100%; border-collapse: collapse;">
// //           <thead>
// //             <tr style="background-color: #f2f2f2;">
// //               <th style="border: 1px solid #ddd; padding: 8px;">S.No</th>
// //               <th style="border: 1px solid #ddd; padding: 8px;">Category</th>
// //               <th style="border: 1px solid #ddd; padding: 8px;">Type</th>
// //               <th style="border: 1px solid #ddd; padding: 8px;">Weight</th>
// //               <th style="border: 1px solid #ddd; padding: 8px;">Total</th>
// //               <th style="border: 1px solid #ddd; padding: 8px;">Stock IDs</th>
// //             </tr>
// //           </thead>
// //           <tbody>
// //             ${filteredData
// //               .map(
// //                 (item, index) => {
// //                   const userId = localStorage.getItem("username");
// //                   const notification = notifications.find(
// //                     (notif) =>
// //                       notif.table_id === item.id?.toString() &&
// //                       notif.employe_id === userId &&
// //                       notif.viewed === "false"
// //                   );
// //                   let rowClass = "";
// //                   if (notification) {
// //                     switch (notification.status) {
// //                       case "accepted":
// //                         rowClass = "background-color: #e2e3e5;";
// //                         break;
// //                       case "rejected":
// //                         rowClass = "background-color: #f8d7da;";
// //                         break;
// //                       case "requested":
// //                         rowClass = "background-color: #cff4fc;";
// //                         break;
// //                     }
// //                   }
// //                   return `
// //                     <tr style="${rowClass}">
// //                       <td style="border: 1px solid #ddd; padding: 8px;">${index + 1}</td>
// //                       <td style="border: 1px solid #ddd; padding: 8px;">${item.category || "N/A"}</td>
// //                       <td style="border: 1px solid #ddd; padding: 8px;">${item.type || item.item || "N/A"}</td>
// //                       <td style="border: 1px solid #ddd; padding: 8px;">${item.weight || "N/A"}</td>
// //                       <td style="border: 1px solid #ddd; padding: 8px;">${item.total || item.total_quantity || "N/A"}</td>
// //                       <td style="border: 1px solid #ddd; padding: 8px;">${
// //                         item.stock_ids && item.stock_ids.length > 0
// //                           ? item.stock_ids.join(", ")
// //                           : "No IDs"
// //                       }</td>
// //                     </tr>
// //                   `;
// //                 }
// //               )
// //               .join("")}
// //           </tbody>
// //         </table>
// //       `;
// //     }

// //     const printWindow = window.open("", "_blank");
// //     printWindow.document.write(`
// //       <html>
// //         <head>
// //           <title>${title}</title>
// //           <style>
// //             body { font-family: Arial, sans-serif; margin: 20px; }
// //             h2 { color: #333; text-align: center; margin-bottom: 20px; }
// //             table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
// //             th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
// //             th { background-color: #f2f2f2; font-weight: bold; }
// //             @media print {
// //               body { margin: 0; }
// //               table { page-break-inside: auto; }
// //               tr { page-break-inside: avoid; page-break-after: auto; }
// //             }
// //           </style>
// //         </head>
// //         <body>
// //           ${tableHtml}
// //         </body>
// //       </html>
// //     `);
// //     printWindow.document.close();
// //     printWindow.focus();
// //     printWindow.print();
// //     printWindow.close();
// //     toast.success("Print exported successfully!", 3000, "topRight");
// //   };

// //  const exportPDF = () => {
// //   try {
// //     const doc = new jsPDF();
// //     doc.setFontSize(20);
// //     const title = activeTab === "day-wise" ? "Day-Wise Stock Report" : "Stock Inventory Report";
// //     doc.text(title, 14, 22);
// //     doc.setFontSize(12);
// //     doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 35);

// //     const userId = localStorage.getItem("username");

// //     // Attach rowStyle to filteredData items
// //     filteredData.forEach((item) => {
// //       const notification = notifications.find(
// //         (notif) =>
// //           notif.table_id === item.id?.toString() &&
// //           notif.employe_id === userId &&
// //           notif.viewed === "false"
// //       );
// //       if (notification) {
// //         switch (notification.status) {
// //           case "accepted":
// //             item.rowStyle = { fillColor: [226, 227, 229] };
// //             break;
// //           case "rejected":
// //             item.rowStyle = { fillColor: [248, 215, 218] };
// //             break;
// //           case "requested":
// //             item.rowStyle = { fillColor: [207, 244, 252] };
// //             break;
// //           default:
// //             item.rowStyle = {};
// //         }
// //       } else {
// //         item.rowStyle = {};
// //       }
// //     });

// //     if (activeTab === "day-wise") {
// //       autoTable(doc, {
// //         startY: 45,
// //         head: [
// //           [
// //             "S.No",
// //             "Category",
// //             "Item",
// //             "Weight",
// //             "Total Qty",
// //             "Sold Qty",
// //             "Available Qty",
// //             "Stock IDs",
// //           ],
// //         ],
// //         body: filteredData.map((item, index) => [
// //           index + 1,
// //           item.category || "",
// //           item.item || "",
// //           item.weight || "",
// //           item.total_quantity || "",
// //           item.sold_quantity || "",
// //           item.available_quantity || "", // corrected typo
// //           item.stock_ids && item.stock_ids.length > 0
// //             ? item.stock_ids.join(", ")
// //             : "No IDs",
// //         ]),
// //         styles: { fontSize: 8, cellPadding: 2 },
// //         headStyles: { fillColor: [66, 139, 202], textColor: 255 },
// //         columnStyles: {
// //           0: { cellWidth: 15 },
// //           1: { cellWidth: 25 },
// //           2: { cellWidth: 25 },
// //           3: { cellWidth: 20 },
// //           4: { cellWidth: 20 },
// //           5: { cellWidth: 20 },
// //           6: { cellWidth: 20 },
// //           7: { cellWidth: 30 },
// //         },
// //         didParseCell: (data) => {
// //           if (data.section === "body") {
// //             const rowIndex = data.row.index;
// //             const rowStyle = filteredData[rowIndex].rowStyle;
// //             if (rowStyle) {
// //               data.cell.styles = { ...data.cell.styles, ...rowStyle };
// //             }
// //           }
// //         },
// //       });
// //       doc.save("day_wise_stock_report.pdf");
// //     } else {
// //       autoTable(doc, {
// //         startY: 45,
// //         head: [["S.No", "Category", "Type", "Weight", "Total", "Stock IDs"]],
// //         body: filteredData.map((item, index) => [
// //           index + 1,
// //           item.category || "N/A",
// //           item.type || item.item || "N/A",
// //           item.weight || "N/A",
// //           item.total || item.total_quantity || "N/A",
// //           item.stock_ids && item.stock_ids.length > 0
// //             ? item.stock_ids.join(", ")
// //             : "No IDs",
// //         ]),
// //         styles: { fontSize: 8, cellPadding: 2 },
// //         headStyles: { fillColor: [66, 139, 202], textColor: 255 },
// //         columnStyles: {
// //           0: { cellWidth: 15 },
// //           1: { cellWidth: 25 },
// //           2: { cellWidth: 25 },
// //           3: { cellWidth: 20 },
// //           4: { cellWidth: 20 },
// //           5: { cellWidth: 30 },
// //         },
// //         didParseCell: (data) => {
// //           if (data.section === "body") {
// //             const rowIndex = data.row.index;
// //             const rowStyle = filteredData[rowIndex].rowStyle;
// //             if (rowStyle) {
// //               data.cell.styles = { ...data.cell.styles, ...rowStyle };
// //             }
// //           }
// //         },
// //       });
// //       doc.save("stock_inventory_report.pdf");
// //     }

// //     toast.success("PDF exported successfully!", 3000, "topRight");
// //   } catch (error) {
// //     console.error("Error generating PDF:", error);
// //     toast.error("Failed to generate PDF", 3000, "topRight");
// //   }
// // };



// //   const exportCSV = () => {
// //     let headers;
// //     let rows;
// //     let filename;

// //     if (activeTab === "day-wise") {
// //       headers = [
// //         "S.No",
// //         "Category",
// //         "Item",
// //         "Weight",
// //         "Total Quantity",
// //         "Sold Quantity",
// //         "Available Quantity",
// //         "Stock IDs",
// //       ];
// //       rows = filteredData.map((item, index) => [
// //         index + 1,
// //         item?.category || "",
// //         item.item || "",
// //         item.weight || "",
// //         item.total_quantity || "",
// //         item.sold_quantity || "",
// //         item.avaliable_quantity || "",
// //         item.stock_ids && item.stock_ids.length > 0
// //           ? item.stock_ids.join("; ")
// //           : "No IDs",
// //       ]);
// //       filename = "day_wise_stock_report.csv";
// //     } else {
// //       headers = ["S.No", "Category", "Type", "Weight", "Total", "Stock IDs"];
// //       rows = filteredData.map((item, index) => [
// //         index + 1,
// //         item.category || "N/A",
// //         item.type || item.item || "N/A",
// //         item.weight || "N/A",
// //         item.total || item.total_quantity || "N/A",
// //         item.stock_ids && item.stock_ids.length > 0
// //           ? item.stock_ids.join("; ")
// //           : "No IDs",
// //       ]);
// //       filename = "stock_inventory_report.csv";
// //     }

// //     const csvContent = [
// //       headers.join(","),
// //       ...rows.map((row) => row.map((field) => `"${field}"`).join(",")),
// //     ].join("\n");

// //     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
// //     const link = document.createElement("a");
// //     const url = URL.createObjectURL(blob);
// //     link.setAttribute("href", url);
// //     link.setAttribute("download", filename);
// //     link.style.visibility = "hidden";
// //     document.body.appendChild(link);
// //     link.click();
// //     document.body.removeChild(link);
// //     toast.success("CSV exported successfully!", 3000, "topRight");
// //     URL.revokeObjectURL(url);
// //   };

// //   const exportExcel = () => {
// //     let wsData;
// //     let filename;

// //     if (activeTab === "day-wise") {
// //       wsData = [
// //         [
// //           "S.No",
// //           "Category",
// //           "Item",
// //           "Weight",
// //           "Total Quantity",
// //           "Sold Quantity",
// //           "Available Quantity",
// //           "Stock IDs",
// //         ],
// //         ...filteredData.map((item, index) => [
// //           index + 1,
// //           item?.category || "",
// //           item.item || "",
// //           item.weight || "",
// //           item.total_quantity || "",
// //           item.sold_quantity || "",
// //           item.avaliable_quantity || "",
// //           item.stock_ids && item.stock_ids.length > 0
// //             ? item.stock_ids.join("; ")
// //             : "No IDs",
// //         ]),
// //       ];
// //       filename = "day_wise_stock_report.xlsx";
// //     } else {
// //       wsData = [
// //         ["S.No", "Category", "Type", "Weight", "Total", "Stock IDs"],
// //         ...filteredData.map((item, index) => [
// //           index + 1,
// //           item.category || "N/A",
// //           item.type || item.item || "N/A",
// //           item.weight || "N/A",
// //           item.total || item.total_quantity || "N/A",
// //           item.stock_ids && item.stock_ids.length > 0
// //             ? item.stock_ids.join("; ")
// //             : "No IDs",
// //         ]),
// //       ];
// //       filename = "stock_inventory_report.xlsx";
// //     }

// //     const ws = XLSX.utils.aoa_to_sheet(wsData);
// //     const wb = XLSX.utils.book_new();
// //     XLSX.utils.book_append_sheet(wb, ws, "Stock Report");

// //     const colWidths = wsData[0].map((_, colIndex) => {
// //       const maxLength = Math.max(
// //         ...wsData.map((row) =>
// //           row[colIndex] ? row[colIndex].toString().length : 0
// //         )
// //       );
// //       return { wch: Math.min(maxLength + 2, 50) };
// //     });
// //     ws["!cols"] = colWidths;

// //     XLSX.writeFile(wb, filename);
// //     toast.success("Excel exported successfully!", 3000, "topRight");
// //   };

// //   const copyToClipboard = () => {
// //     let headers;
// //     let rows;

// //     if (activeTab === "day-wise") {
// //       headers = [
// //         "S.No",
// //         "Category",
// //         "Item",
// //         "Weight",
// //         "Total Quantity",
// //         "Sold Quantity",
// //         "Available Quantity",
// //         "Stock IDs",
// //       ];
// //       rows = (filteredData || []).map((item, index) => [
// //         index + 1,
// //         item?.category || "",
// //         item.item || "",
// //         item.weight || "",
// //         item.total_quantity || "",
// //         item.sold_quantity || "",
// //         item.avaliable_quantity || "",
// //         item.stock_ids && item.stock_ids.length > 0
// //           ? item.stock_ids.join("; ")
// //           : "No IDs",
// //       ]);
// //     } else {
// //       headers = ["S.No", "Category", "Type", "Weight", "Total", "Stock IDs"];
// //       rows = (filteredData || []).map((item, index) => [
// //         index + 1,
// //         item.category || "N/A",
// //         item.type || item.item || "N/A",
// //         item.weight || "N/A",
// //         item.total || item.total_quantity || "N/A",
// //         item.stock_ids && item.stock_ids.length > 0
// //           ? item.stock_ids.join("; ")
// //           : "No IDs",
// //       ]);
// //     }

// //     const formattedText = [headers, ...rows]
// //       .map((row) => row.map((field) => `"${field}"`).join("\t"))
// //       .join("\n");

// //     if (navigator.clipboard && navigator.clipboard.writeText) {
// //       navigator.clipboard
// //         .writeText(formattedText)
// //         .then(() => {
// //           toast.success("Table data copied to clipboard!", 3000, "topRight");
// //         })
// //         .catch((err) => {
// //           console.error("Clipboard API failed:", err);
// //           fallbackCopy(formattedText);
// //         });
// //     } else {
// //       fallbackCopy(formattedText);
// //     }
// //   };

// //   const fallbackCopy = (text) => {
// //     try {
// //       const textArea = document.createElement("textarea");
// //       textArea.value = text;
// //       textArea.style.position = "fixed";
// //       textArea.style.top = 0;
// //       textArea.style.left = 0;
// //       textArea.style.width = "2em";
// //       textArea.style.height = "2em";
// //       textArea.style.padding = 0;
// //       textArea.style.border = "none";
// //       textArea.style.outline = "none";
// //       textArea.style.boxShadow = "none";
// //       textArea.style.background = "transparent";

// //       document.body.appendChild(textArea);
// //       textArea.focus();
// //       textArea.select();

// //       const successful = document.execCommand("copy");
// //       document.body.removeChild(textArea);

// //       if (successful) {
// //         toast.success("Table data copied to clipboard!", 3000, "topRight");
// //       } else {
// //         toast.error("Failed to copy data", 3000, "topRight");
// //       }
// //     } catch (err) {
// //       console.error("Fallback copy failed:", err);
// //       toast.error("Failed to copy data", 3000, "topRight");
// //     }
// //   };

// //   // Render pagination buttons
// //   const renderPageNumbers = () => {
// //     if (showAllItems || totalPages <= 1) return null;

// //     const pages = [];
// //     const maxVisiblePages = 5;

// //     let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
// //     let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

// //     if (endPage - startPage + 1 < maxVisiblePages) {
// //       startPage = Math.max(1, endPage - maxVisiblePages + 1);
// //     }

// //     if (startPage > 1) {
// //       pages.push(
// //         <li
// //           key={1}
// //           className={`page-item ${currentPage === 1 ? "active" : ""}`}
// //         >
// //           <button className="page-link" onClick={() => handlePageChange(1)}>
// //             1
// //           </button>
// //         </li>
// //       );
// //       if (startPage > 2) {
// //         pages.push(
// //           <li key="start-ellipsis" className="page-item disabled">
// //             <span className="page-link">...</span>
// //           </li>
// //         );
// //       }
// //     }

// //     for (let i = startPage; i <= endPage; i++) {
// //       pages.push(
// //         <li
// //           key={i}
// //           className={`page-item ${currentPage === i ? "active" : ""}`}
// //         >
// //           <button className="page-link" onClick={() => handlePageChange(i)}>
// //             {i}
// //           </button>
// //         </li>
// //       );
// //     }

// //     if (endPage < totalPages) {
// //       if (endPage < totalPages - 1) {
// //         pages.push(
// //           <li key="end-ellipsis" className="page-item disabled">
// //             <span className="page-link">...</span>
// //           </li>
// //         );
// //       }
// //       pages.push(
// //         <li
// //           key={totalPages}
// //           className={`page-item ${currentPage === totalPages ? "active" : ""}`}
// //         >
// //           <button
// //             className="page-link"
// //             onClick={() => handlePageChange(totalPages)}
// //           >
// //             {totalPages}
// //           </button>
// //         </li>
// //       );
// //     }

// //     return pages;
// //   };

// //   const userRole = localStorage.getItem("role");

// //   const handleEdit = (item) => {
// //     const stockId = item.id || item.stock_ids?.[0]; // Use item.id or first stock_id
// //     if (userRole === "Employee") {
// //       if (checkNotificationStatus(stockId, "Edit")) {
// //         navigate(`/Viewstock/${item.stock_ids.join(",")}`);
// //       } else {
// //         openNotificationModal(stockId, "Edit");
// //       }
// //     } else {
// //       navigate(`/Viewstock/${item.stock_ids.join(",")}`);
// //     }
// //   };

// //   const handleDelete = (item) => {
// //     const stockId = item.id || item.stock_ids?.[0]; // Use item.id or first stock_id
// //     if (userRole === "Employee") {
// //       if (checkNotificationStatus(stockId, "Delete")) {
// //         setItemToDelete(item);
// //         setShowDeleteModal(true);
// //       } else {
// //         openNotificationModal(stockId, "Delete");
// //       }
// //     } else {
// //       setItemToDelete(item);
// //       setShowDeleteModal(true);
// //     }
// //   };

// //   const closeDeleteModal = () => {
// //     setShowDeleteModal(false);
// //     setItemToDelete(null);
// //   };

// //   const confirmDelete = async () => {
// //     if (!itemToDelete) return;

// //     try {
// //       setDeleteLoading(true);

// //       const stockIdsToDelete = itemToDelete.stock_ids || [];
// //       if (stockIdsToDelete.length === 0) {
// //         throw new Error("No stock IDs found to delete");
// //       }

// //       const deleteData = {
// //         stock_ids: stockIdsToDelete,
// //         item_name: itemToDelete.item,
// //         category: itemToDelete.category,
// //       };

// //       const response = await axios.delete(`${ApiUrl}/Api/stock.php`, {
// //         data: deleteData,
// //         headers: { "Content-Type": "application/json" },
// //       });

// //       if (response.data.success) {
// //         // Update notification if it exists
// //         const stockId = itemToDelete.id || itemToDelete.stock_ids?.[0];
// //         const notification = notifications.find(
// //           (notif) =>
// //             notif.table_id === stockId.toString() &&
// //             notif.button_value === "Delete" &&
// //             notif.viewed === "false"
// //         );
// //         if (notification) {
// //           const currentTime = new Date().toISOString().slice(0, 19).replace("T", " ");
// //           const notificationPayload = {
// //             id: notification.id,
// //             viewed: "true",
// //             updated_by: localStorage.getItem("username"),
// //             updated_date: currentTime,
// //             table_name: notification.table_name,
// //             table_id: notification.table_id,
// //             employe_id: notification.employe_id,
// //             status: notification.status,
// //             button_value: notification.button_value,
// //             time: notification.time,
// //             created_date: notification.created_date,
// //           };

// //           await axios.put(
// //             `${ApiUrl}/Api/notification.php/${notification.id}`,
// //             notificationPayload,
// //             {
// //               headers: { "Content-Type": "application/json" },
// //             }
// //           );
// //         }

// //         setResponseData((prevData) =>
// //           prevData.filter((item) => {
// //             if (!item.stock_ids || !Array.isArray(item.stock_ids)) return true;
// //             const hasOverlap = item.stock_ids.some((stockId) =>
// //               stockIdsToDelete.includes(stockId)
// //             );
// //             return !hasOverlap;
// //           })
// //         );

// //         toast.success(
// //           `Stock item "${itemToDelete.item}" deleted successfully`,
// //           3000,
// //           "topRight"
// //         );

// //         closeDeleteModal();

// //         const remainingItems = responseData.filter((item) => {
// //           if (!item.stock_ids || !Array.isArray(item.stock_ids)) return true;
// //           const hasOverlap = item.stock_ids.some((stockId) =>
// //             stockIdsToDelete.includes(stockId)
// //           );
// //           return !hasOverlap;
// //         });

// //         if (!showAllItems) {
// //           const newTotalPages = Math.ceil(remainingItems.length / itemsPerPage);
// //           if (currentPage > newTotalPages && newTotalPages > 0) {
// //             setCurrentPage(newTotalPages);
// //           }
// //         }

// //         if (response.data.warnings && response.data.warnings.length > 0) {
// //           console.warn("Delete warnings:", response.data.warnings);
// //           toast.warning(
// //             `Some issues occurred: ${response.data.warnings.join(", ")}`,
// //             5000,
// //             "topRight"
// //           );
// //         }

// //         fetchNotifications();
// //       } else {
// //         throw new Error(response.data.message || "Delete operation failed");
// //       }
// //     } catch (error) {
// //       console.error("Error deleting stock item:", error);
// //       let errorMessage = "Failed to delete stock item";
// //       if (error.response?.data?.message) {
// //         errorMessage = error.response.data.message;
// //       } else if (error.message) {
// //         errorMessage = error.message;
// //       }
// //       toast.error(errorMessage, 5000, "topRight");
// //     } finally {
// //       setDeleteLoading(false);
// //     }
// //   };

// //   // Delete Modal Component
// //   const DeleteModal = () => {
// //     if (!showDeleteModal || !itemToDelete) return null;

// //     return (
// //       <div
// //         className="modal fade show d-block"
// //         tabIndex="-1"
// //         style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
// //       >
// //         <div className="modal-dialog modal-dialog-centered modal-xl">
// //           <div className="modal-content">
// //             <div className="modal-header bg-danger text-white">
// //               <h5 className="modal-title">
// //                 <i className="fas fa-exclamation-triangle me-2"></i>
// //                 Confirm Delete Stock Item
// //               </h5>
// //               <button
// //                 type="button"
// //                 className="btn-close btn-close-white"
// //                 onClick={closeDeleteModal}
// //                 disabled={deleteLoading}
// //               ></button>
// //             </div>
// //             <div className="modal-body">
// //               <div className="alert alert-warning d-flex align-items-center mb-4">
// //                 <i
// //                   className="fas fa-exclamation-triangle me-3"
// //                   style={{ fontSize: "2rem" }}
// //                 ></i>
// //                 <div>
// //                   <h6 className="mb-1">
// //                     Warning: This action cannot be undone!
// //                   </h6>
// //                   <p className="mb-0">
// //                     You are about to permanently delete this stock item and all
// //                     its associated records.
// //                   </p>
// //                 </div>
// //               </div>

// //               <div className="row">
// //                 <div className="col-md-6">
// //                   <div className="card border-primary h-100">
// //                     <div className="card-header bg-primary text-white">
// //                       <h6 className="mb-0">
// //                         <i className="fas fa-info-circle me-2"></i>
// //                         Item Summary
// //                       </h6>
// //                     </div>
// //                     <div className="card-body">
// //                       <table className="table table-borderless table-sm">
// //                         <tbody>
// //                           <tr>
// //                             <td><strong>Item Name:</strong></td>
// //                             <td>{itemToDelete.item}</td>
// //                           </tr>
// //                           <tr>
// //                             <td><strong>Category:</strong></td>
// //                             <td>
// //                               <span
// //                                 className={`badge ${
// //                                   itemToDelete.category === "Gold"
// //                                     ? "bg-warning text-dark"
// //                                     : "bg-secondary"
// //                                 }`}
// //                               >
// //                                 {itemToDelete.category}
// //                               </span>
// //                             </td>
// //                           </tr>
// //                           <tr>
// //                             <td><strong>Weight:</strong></td>
// //                             <td>{itemToDelete.weight}</td>
// //                           </tr>
// //                           <tr>
// //                             <td><strong>Total Quantity:</strong></td>
// //                             <td>
// //                               <span className="badge bg-info">
// //                                 {itemToDelete.total_quantity}
// //                               </span>
// //                             </td>
// //                           </tr>
// //                           <tr>
// //                             <td><strong>Sold Quantity:</strong></td>
// //                             <td>
// //                               <span className="badge bg-success">
// //                                 {itemToDelete.sold_quantity}
// //                               </span>
// //                             </td>
// //                           </tr>
// //                           <tr>
// //                             <td><strong>Available Quantity:</strong></td>
// //                             <td>
// //                               <span className="badge bg-primary">
// //                                 {itemToDelete.avaliable_quantity}
// //                               </span>
// //                             </td>
// //                           </tr>
// //                         </tbody>
// //                       </table>
// //                     </div>
// //                   </div>
// //                 </div>

// //                 <div className="col-md-6">
// //                   <div className="card border-warning h-100">
// //                     <div className="card-header bg-warning text-dark">
// //                       <h6 className="mb-0">
// //                         <i className="fas fa-database me-2"></i>
// //                         Records to Delete
// //                       </h6>
// //                     </div>
// //                     <div className="card-body">
// //                       <div className="mb-3">
// //                         <strong>Stock IDs:</strong>
// //                         <div className="mt-2">
// //                           {itemToDelete.stock_ids &&
// //                             itemToDelete.stock_ids.map((stockId, index) => (
// //                               <span
// //                                 key={index}
// //                                 className="badge bg-danger me-1 mb-1"
// //                               >
// //                                 ID: {stockId}
// //                               </span>
// //                             ))}
// //                         </div>
// //                       </div>

// //                       {itemToDelete.stock_list &&
// //                         itemToDelete.stock_list.length > 0 && (
// //                           <>
// //                             <strong>
// //                               Stock Records ({itemToDelete..length}{" "}
// //                               total):
// //                             </strong>
// //                             <div
// //                               className="mt-2"
// //                               style={{ maxHeight: "200px", overflowY: "auto" }}
// //                             >
// //                               {itemToDelete.stock_list.map((stock, index) => (
// //                                 <div
// //                                   key={index}
// //                                   className="border rounded p-2 mb-2 bg-light"
// //                                 >
// //                                   <div className="row">
// //                                     <div className="col-6">
// //                                       <small>
// //                                         <strong>Record ID:</strong> {stock.id}
// //                                         <br />
// //                                         <strong>Date:</strong> {stock.date}
// //                                         <br />
// //                                         <strong>Stock ID:</strong>{" "}
// //                                         {stock.overall_stock_id}
// //                                       </small>
// //                                     </div>
// //                                     <div className="col-6">
// //                                       <small>
// //                                         <strong>Quantity:</strong>{" "}
// //                                         {stock.quantity}
// //                                         <br />
// //                                         <strong>Status:</strong>
// //                                         <span
// //                                           className={`badge ms-1 ${
// //                                             stock.status === "in"
// //                                               ? "bg-success"
// //                                               : "bg-warning text-dark"
// //                                           }`}
// //                                         >
// //                                           {stock.status}
// //                                         </span>
// //                                         <br />
// //                                         <strong>Available:</strong>{" "}
// //                                         {stock.available_quantity}
// //                                       </small>
// //                                     </div>
// //                                   </div>
// //                                 </div>
// //                               ))}
// //                             </div>
// //                           </>
// //                         )}
// //                     </div>
// //                   </div>
// //                 </div>
// //               </div>

// //               <div className="alert alert-danger mt-3 mb-0">
// //                 <strong>Impact:</strong> Deleting this item will remove{" "}
// //                 <strong>{itemToDelete.stock_list?.length || 0}</strong> database
// //                 records and make{" "}
// //                 <strong>{itemToDelete.avaliable_quantity}</strong> units
// //                 unavailable.
// //               </div>
// //             </div>
// //             <div className="modal-footer">
// //               <button
// //                 type="button"
// //                 className="btn btn-secondary"
// //                 onClick={closeDeleteModal}
// //                 disabled={deleteLoading}
// //               >
// //                 <i className="fas fa-times me-2"></i>
// //                 Cancel
// //               </button>
// //               <button
// //                 type="button"
// //                 className="btn btn-danger"
// //                 onClick={confirmDelete}
// //                 disabled={deleteLoading}
// //               >
// //                 {deleteLoading ? (
// //                   <>
// //                     <span
// //                       className="spinner-border spinner-border-sm me-2"
// //                       role="status"
// //                     ></span>
// //                     Deleting...
// //                   </>
// //                 ) : (
// //                   <>
// //                     <i className="fas fa-trash me-2"></i>
// //                     Permanently Delete
// //                   </>
// //                 )}
// //               </button>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     );
// //   };

// //   // // Notification Modal
// //   // Ascending
// //   const NotificationModal = () => (
// //     <div
// //       className={`modal fade ${showNotificationModal ? "show" : ""}`}
// //       style={{ display: showNotificationModal ? "block" : "none", backgroundColor: "rgba(0,0,0,0.5)" }}
// //       tabIndex="-1"
// //       aria-labelledby="notificationModalLabel"
// //       aria-hidden={!showNotificationModal}
// //     >
// //       <div className="modal-dialog modal-dialog-centered">
// //         <div className="modal-content">
// //           <div className="modal-header">
// //             <h6 className="modal-title text-primary" id="notificationModalLabel">
// //               Send {actionType} Request to Admin
// //             </h6>
// //             <button
// //               type="button"
// //               className="btn-close"
// //               style={{ fontSize: "10px" }}
// //               onClick={closeNotificationModal}
// //               aria-label="Close"
// //             ></button>
// //           </div>
// //           <div className="modal-body">
// //             <form onSubmit={handleNotificationSubmit}>
// //               <p className="text-center">
// //                 Do you want to request to {actionType.toLowerCase()} this stock item?
// //               </p>
// //               <div className="text-center mt-4">
// //                 <button
// //                   type="button"
// //                   className="btn btn-secondary btn-sm px-4 me-2"
// //                   onClick={closeNotificationModal}
// //                 >
// //                   No
// //                 </button>
// //                 <button
// //                   type="submit"
// //                   className="btn btn-primary btn-sm px-4"
// //                   disabled={isSubmitting}
// //                 >
// //                   Yes
// //                 </button>
// //               </div>
// //             </form>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );

// //   return (
// //     <div className="container-fluid py-3">
// //       {/* {loading && (
// //         <div className="loading-overlay">
// //           <div className="loading-message">
// //             <div className="loadinggif"></div>
// //           </div>
// //         </div>
// //       )} */}

// //       <>
// //         <div className="row mt-2">
// //           <div className="col-lg-2">
// //             <button
// //               className="btn btn-primary btn-sm rounded-3"
// //               style={{ marginTop: "-30px" }}
// //               onClick={handleAddStock}
// //             >
// //               Add Stock <i className="fa-solid fa-plus mx-1"></i>
// //             </button>
// //           </div>
// //           <div className="col-lg-7"></div>
// //           <div className="col-lg-3">
// //             {userRole === "Admin" && (
// //               <button
// //                 className="btn btn-success btn-sm rounded-3"
// //                 style={{ marginTop: "-30px" }}
// //                 onClick={handleAddPersonalStock}
// //               >
// //                 Personal Stock <i className="fa-solid fa-plus mx-1"></i>
// //               </button>
// //             )}
// //           </div>
// //         </div>
// //         <div className="">
// //           {/* Tabs */}
// //           <div className="card shadow-sm border-0 rounded-3 mb-2">
// //             <div className="row p-2">
// //               <div className="col-auto">
// //                 <button
// //                   className={`btn btn-link text-decoration-none px-3 ${
// //                     activeTab === "day-wise"
// //                       ? "text-white border-bottom bg-primary"
// //                       : "text-dark"
// //                   }`}
// //                   onClick={() => handleTabClick("day-wise")}
// //                 >
// //                   <span style={{ fontSize: "13px" }}>Day-Wise</span>
// //                 </button>
// //                 <button
// //                   className={`btn btn-link text-decoration-none px-3 ms-3 ${
// //                     activeTab === "stock-inventory"
// //                       ? "text-white border-bottom bg-primary"
// //                       : "text-dark"
// //                   }`}
// //                   onClick={() => handleTabClick("stock-inventory")}
// //                 >
// //                   <span style={{ fontSize: "13px" }}>Stock Inventory</span>
// //                 </button>
// //               </div>
// //             </div>
// //           </div>

// //           {/* Content */}
// //           {activeTab === "day-wise" && (
// //             <>
// //               <div className="row mb-2">
// //                 <div className="col-lg-3">
// //                   <div className="card p-2">
// //                     <h6>Total Buy Qty</h6>
// //                     <p className="fw-bold">{stocktotal.total_buy_qty || 0}</p>
// //                   </div>
// //                 </div>
// //                 <div className="col-lg-3">
// //                   <div className="card p-2">
// //                     <h6>Total Sales Qty</h6>
// //                     <p className="fw-bold">{stocktotal.total_sales_qty || 0}</p>
// //                   </div>
// //                 </div>
// //                 <div className="col-lg-3">
// //                   <div className="card p-2">
// //                     <h6>Item Sold Today</h6>
// //                     <p className="fw-bold">{stocktotal.items_sold_today || 0}</p>
// //                   </div>
// //                 </div>
// //                 <div className="col-lg-3">
// //                   <div className="card p-2">
// //                     <h6>Available Qty</h6>
// //                     <p className="fw-bold">{stocktotal.available_qty || 0}</p>
// //                   </div>
// //                 </div>
// //               </div>
// //               <div className="card shadow-sm">
// //                 <div className="card-body">
// //                   <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-3">
// //                     <div className="d-flex align-items-center mb-2 mb-md-0">
// //                       <label className="form-label text-dark mb-0 me-2">
// //                         Show:{" "}
// //                       </label>
// //                       <div>
// //                         <select
// //                           className="form-control"
// //                           onChange={handleItemsPerPageChange}
// //                           value={showAllItems ? "All" : itemsPerPage}
// //                         >
// //                           <option value="All">All</option>
// //                           {[5, 10, 20, 100, 200, 500, 1000].map((pageSize) => (
// //                             <option key={pageSize} value={pageSize}>
// //                               {pageSize}
// //                             </option>
// //                           ))}
// //                         </select>
// //                       </div>
// //                     </div>

// //                     <div className="d-flex justify-content-center mb-2 mb-md-0 flex-wrap">
// //                       <button
// //                         className="btn btn-sm btn-info text-white mx-1 mb-1 mb-md-0"
// //                         onClick={handlePrint}
// //                       >
// //                         Print
// //                       </button>
// //                       <button
// //                         className="btn btn-sm btn-info text-white mx-1 mb-1 mb-md-0"
// //                         onClick={exportPDF}
// //                       >
// //                         PDF
// //                       </button>
// //                       <button
// //                         className="btn btn-sm btn-info text-white mx-1 mb-1 mb-md-0"
// //                         onClick={copyToClipboard}
// //                       >
// //                         Copy
// //                       </button>
// //                       <button
// //                         className="btn btn-sm btn-info text-white mx-1 mb-1 mb-md-0"
// //                         onClick={exportCSV}
// //                       >
// //                         CSV
// //                       </button>
// //                       <button
// //                         className="btn btn-sm btn-info text-white mx-1 mb-1 mb-md-0"
// //                         onClick={exportExcel}
// //                       >
// //                         Excel
// //                       </button>
// //                     </div>

// //                     <div className="search-container w-25">
// //                       <div className="input-group">
// //                         <input
// //                           type="text"
// //                           className="form-control"
// //                           placeholder="Search"
// //                           aria-label="Search"
// //                           value={searchTerm}
// //                           onChange={(e) => setSearchTerm(e.target.value)}
// //                         />
// //                       </div>
// //                     </div>
// //                   </div>

// //                   {/* Table */}
// //                   <div className="card tableCard p-2">
// //                     <div className="table-responsive">
// //                       <table className="table table-hover w-100">
// //                         <thead className="bg-light">
// //                           <tr>
// //                             <th>S.No</th>
// //                             <th>Category</th>
// //                             <th>Item</th>
// //                             <th>Weight</th>
// //                             <th>Total Quantity</th>
// //                             <th>Sold Quantity</th>
// //                             <th>Available Quantity</th>
                         
// //                             <th>Actions</th>
// //                           </tr>
// //                         </thead>
// //                         <tbody>
// //                           {currentItems.length > 0 ? (
// //                             currentItems.map((item, index) => {
// //                               const userId = localStorage.getItem("username");
// //                               const notification = notifications.find(
// //                                 (notif) =>
// //                                   notif.table_id === (item.id || item.stock_ids?.[0])?.toString() &&
// //                                   notif.employe_id === userId &&
// //                                   notif.viewed === "false"
// //                               );
// //                               let rowClass = "";
// //                               if (notification) {
// //                                 switch (notification.status) {
// //                                   case "accepted":
// //                                     rowClass = "table-secondary";
// //                                     break;
// //                                   case "rejected":
// //                                     rowClass = "table-danger";
// //                                     break;
// //                                   case "requested":
// //                                     rowClass = "table-info";
// //                                     break;
// //                                 }
// //                               }
// //                               return (
// //                                 <tr key={item.id || `inventory-${index}`} className={rowClass}>
// //                                   <td>
// //                                     {showAllItems
// //                                       ? index + 1
// //                                       : (currentPage - 1) * itemsPerPage +
// //                                         index +
// //                                         1}
// //                                   </td>
// //                                   <td>{item?.category}</td>
// //                                   <td>{item.item}</td>
// //                                   <td>{item.weight}</td>
// //                                   <td>{item.total_quantity}</td>
// //                                   <td>{item.sold_quantity}</td>
// //                                   <td>{item.avaliable_quantity}</td>
                               
// //                                   <td>
// //                                     <button
// //                                       className="btn btn-light btn-sm mx-1"
// //                                       onClick={() => handleEdit(item)}
// //                                       title="Edit"
// //                                     >
// //                                       <i className="fa-solid fa-list text-primary fs-6"></i>
// //                                     </button>
// //                                     <button
// //                                       className="btn btn-light btn-sm"
// //                                       onClick={() => handleDelete(item)}
// //                                       title="Delete"
// //                                     >
// //                                       <i className="fa-solid fa-trash text-danger fs-6"></i>
// //                                     </button>
// //                                   </td>
// //                                 </tr>
// //                               );
// //                             })
// //                           ) : (
// //                             <tr>
// //                               <td colSpan="9" className="text-center">
// //                                 No data available
// //                               </td>
// //                             </tr>
// //                           )}
// //                         </tbody>
// //                       </table>
// //                     </div>

// //                     {/* Pagination */}
// //                     {!showAllItems && totalPages > 1 && (
// //                       <nav aria-label="Page navigation">
// //                         <ul className="pagination justify-content-end mt-3">
// //                           <li
// //                             className={`page-item ${
// //                               currentPage === 1 ? "disabled" : ""
// //                             }`}
// //                           >
// //                             <button
// //                               className="page-link"
// //                               onClick={() => handlePageChange(currentPage - 1)}
// //                               disabled={currentPage === 1}
// //                             >
// //                               Previous
// //                             </button>
// //                           </li>
// //                           {renderPageNumbers()}
// //                           <li
// //                             className={`page-item ${
// //                               currentPage === totalPages ? "disabled" : ""
// //                             }`}
// //                           >
// //                             <button
// //                               className="page-link"
// //                               onClick={() => handlePageChange(currentPage + 1)}
// //                               disabled={currentPage === totalPages}
// //                             >
// //                               Next
// //                             </button>
// //                           </li>
// //                         </ul>
// //                       </nav>
// //                     )}
// //                   </div>
// //                 </div>
// //               </div>
// //             </>
// //           )}

// //           {activeTab === "stock-inventory" && (
// //             <>
// //               <div className="row mb-2">
// //                 <div className="col-lg-3">
// //                   <div className="card p-2">
// //                     <h6>Total Gold Stock</h6>
// //                     <p className="fw-bold text-warning">{stocktotalinventory.Total_Gold_Stock || 0}</p>
// //                   </div>
// //                 </div>
// //                 <div className="col-lg-3">
// //                   <div className="card p-2">
// //                     <h6>Total Silver Stock</h6>
// //                     <p className="fw-bold text-secondary">{stocktotalinventory.Total_Silver_Stock || 0}</p>
// //                   </div>
// //                 </div>
// //                 <div className="col-lg-3">
// //                   <div className="card p-2">
// //                     <h6>Total Items</h6>
// //                     <p className="fw-bold">{stocktotalinventory.Total_Items || 0}</p>
// //                   </div>
// //                 </div>
// //               </div>
// //               <div
// //                 className="card shadow-sm border-0 rounded-3"
// //                 style={{ background: "#ffffff", opacity: 0.9 }}
// //               >
// //                 <div className="card-body">
// //                   <div className="row align-items-center mb-4">
// //                     <div className="col-md-9">
// //                       <h6 className="mb-0">Stock Inventory</h6>
// //                     </div>
// //                     <div className="col-md-3">
// //                       <div className="position-relative">
// //                         <i className="fas fa-search position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
// //                         <input
// //                           type="search"
// //                           className="form-control ps-5"
// //                           placeholder="Search..."
// //                           value={searchTerm}
// //                           onChange={(e) => setSearchTerm(e.target.value)}
// //                         />
// //                       </div>
// //                     </div>
// //                   </div>

// //                   <div className="card tableCard p-2">
// //                     <div className="table-responsive">
// //                       <table className="table table-hover w-100">
// //                         <thead className="bg-light">
// //                           <tr>
// //                             <th>S.No</th>
// //                             <th>Category</th>
// //                             <th>Type</th>
// //                             <th>Weight</th>
// //                             <th>Total</th>
                          
// //                             <th>Actions</th>
// //                           </tr>
// //                         </thead>
// //                         <tbody>
// //                           {currentItems.length > 0 ? (
// //                             currentItems.map((item, index) => {
// //                               const userId = localStorage.getItem("username");
// //                               const notification = notifications.find(
// //                                 (notif) =>
// //                                   notif.table_id === (item.id || item.stock_ids?.[0])?.toString() &&
                            
// //                                   notif.viewed === "false"
// //                               );
// //                               let rowClass = "";
// //                               if (notification) {
// //                                 switch (notification.status) {
// //                                   case "accepted":
// //                                     rowClass = "table-secondary";
// //                                     break;
// //                                   case "rejected":
// //                                     rowClass = "table-danger";
// //                                     break;
// //                                   case "requested":
// //                                     rowClass = "table-info";
// //                                     break;
// //                                 }
// //                               }
// //                               return (
// //                                 <tr key={item.id || `inventory-${index}`} className={rowClass}>
// //                                   <td>
// //                                     {showAllItems
// //                                       ? index + 1
// //                                       : (currentPage - 1) * itemsPerPage +
// //                                         index +
// //                                         1}
// //                                   </td>
// //                                   <td>{item.category || "N/A"}</td>
// //                                   <td>{item.type || item.item || "N/A"}</td>
// //                                   <td>{item.weight || "N/A"}</td>
// //                                   <td>
// //                                     {item.total || item.total_quantity || "N/A"}
// //                                   </td>
                             
// //                                   <td>
// //                                     <button
// //                                       className="btn btn-light btn-sm mx-1"
// //                                       onClick={() => handleEdit(item)}
// //                                       title="Edit"
// //                                     >
// //                                       <i className="fa-solid fa-pen-to-square text-primary fs-6"></i>
// //                                     </button>
// //                                     <button
// //                                       className="btn btn-light btn-sm"
// //                                       onClick={() => handleDelete(item)}
// //                                       title="Delete"
// //                                     >
// //                                       <i className="fa-solid fa-trash text-danger fs-6"></i>
// //                                     </button>
// //                                   </td>
// //                                 </tr>
// //                               );
// //                             })
// //                           ) : (
// //                             <tr>
// //                               <td colSpan="7" className="text-center">
// //                                 No data available
// //                               </td>
// //                             </tr>
// //                           )}
// //                         </tbody>
// //                       </table>
// //                     </div>

// //                     {/* Pagination */}
// //                     {!showAllItems && totalPages > 1 && (
// //                       <nav aria-label="Page navigation">
// //                         <ul className="pagination justify-content-end mt-3">
// //                           <li
// //                             className={`page-item ${
// //                               currentPage === 1 ? "disabled" : ""
// //                             }`}
// //                           >
// //                             <button
// //                               className="page-link"
// //                               onClick={() => handlePageChange(currentPage - 1)}
// //                               disabled={currentPage === 1}
// //                             >
// //                               Previous
// //                             </button>
// //                           </li>
// //                           {renderPageNumbers()}
// //                           <li
// //                             className={`page-item ${
// //                               currentPage === totalPages ? "disabled" : ""
// //                             }`}
// //                           >
// //                             <button
// //                               className="page-link"
// //                               onClick={() => handlePageChange(currentPage + 1)}
// //                               disabled={currentPage === totalPages}
// //                             >
// //                               Next
// //                             </button>
// //                           </li>
// //                         </ul>
// //                       </nav>
// //                     )}
// //                   </div>
// //                 </div>
// //               </div>
// //             </>
// //           )}
// //         </div>
// //       </>

// //       {/* Modals */}
// //       <DeleteModal />
// //       <NotificationModal />
// //       {(showDeleteModal || showNotificationModal) && (
// //         <div className="modal-backdrop fade show"></div>
// //       )}
// //     </div>
// //   );
// // }

// // export default Stock;





// // ////////////////////////////////////


// // import axios from "axios";
// // import { useState, useEffect } from "react";
// // import ApiUrl from "./../Environment/ApiUrl";
// // import { useToast } from "../Toast/ToastContext";
// // import { useNavigate } from "react-router-dom";

// // function AddStock() {
// //   const navigate = useNavigate();
// //   const toast = useToast();

// //   const [items, setItems] = useState([]);
// //   const [typeGetting, setTypeGetting] = useState([]);
// //   const [editingIndex, setEditingIndex] = useState(null);

// //   const [addData, setAddData] = useState({
// //     item: "",
// //     quantity: "",
// //     category: "",
// //     weight: "",
// //     date: new Date().toISOString().split("T")[0],
// //     created_by: "",
// //     created_date: "",
// //   });

// //   useEffect(() => {
// //     fetchProductType();
// //   }, []);

// //   const fetchProductType = async () => {
// //     try {
// //       const response = await axios.get(`${ApiUrl}/Api/product_type.php`);
// //       setTypeGetting(response.data?.data || []);
// //     } catch (error) {
// //       console.error("Error fetching product types:", error.message);
// //       setTypeGetting([]);
// //       toast.error("Error fetching product types", 3000, "topRight");
// //     }
// //   };

// //   const handleAddItem = () => {
// //     if (
// //       !addData.category ||
// //       !addData.item ||
// //       !addData.quantity ||
// //       !addData.weight
// //     ) {
// //       toast.error("Please fill all required fields", 3000, "topRight");
// //       return;
// //     }

// //     // Get the selected type name for display
// //     const selectedType = typeGetting.find((type) => type._id === addData.item);
// //     const typeName = selectedType ? selectedType.type : addData.item;

// //     const newItem = {
// //       date: addData.date,
// //       status: "in", // Adding status as shown in your expected structure
// //       item: typeName, // Use the type name for display
// //       type_id: addData.item, // Keep the ID for reference
// //       quantity: addData.quantity,
// //       category: addData.category,
// //       weight: addData.weight,
// //       created_by: "",
// //       created_date: "",
// //       updated_by: "",
// //       updated_date: "",
// //     };

// //     if (editingIndex !== null) {
// //       const updatedItems = [...items];
// //       updatedItems[editingIndex] = newItem;
// //       setItems(updatedItems);
// //       setEditingIndex(null);
// //     } else {
// //       setItems([...items, newItem]);
// //     }

// //     setAddData((prev) => ({
// //       ...prev,
// //       item: "",
// //       quantity: "",
// //       weight: "",
// //       category: "",
// //     }));
// //   };

// //   const handleEditItem = (index) => {
// //     const itemToEdit = items[index];
// //     setAddData({
// //       ...addData,
// //       item: itemToEdit.type_id || itemToEdit.item,
// //       quantity: itemToEdit.quantity,
// //       category: itemToEdit.category,
// //       weight: itemToEdit.weight,
// //       date: itemToEdit.date,
// //     });
// //     setEditingIndex(index);
// //   };

// //   const handleRemoveItem = (index) => {
// //     const updatedItems = items.filter((_, i) => i !== index);
// //     setItems(updatedItems);
// //   };

// //   // Calculate totals for the overall stock
// //   const calculateTotals = () => {
// //     const totalQuantity = items.reduce(
// //       (sum, item) => sum + parseInt(item.quantity || 0),
// //       0
// //     );
// //     const totalWeight = items.reduce(
// //       (sum, item) => sum + parseFloat(item.weight || 0),
// //       0
// //     );

// //     return {
// //       total_quantity: totalQuantity,
// //       total_weight: totalWeight,
// //       available_quantity: totalQuantity, // Initially all items are available
// //       sold_quantity: 0, // Initially no items are sold
// //     };
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();

// //     if (items.length === 0) {
// //       toast.error("Please add at least one item", 3000, "topRight");
// //       return;
// //     }

// //     try {
// //       const totals = calculateTotals();

// //       // Get the main category and item name for the overall stock
// //       const mainCategory = items[0]?.category || "";
// //       const mainItemName =
// //         items.length === 1 ? items[0].item : `${mainCategory} Items`;

// //       const payload = {
// //         // Overall stock information
// //         item: mainItemName,
// //         quantity: totals.total_quantity.toString(),
// //         amount: "0", // You might want to calculate this based on rates
// //         category: mainCategory,
// //         weight: `${totals.total_weight}g`,
// //         avaliable_quantity: totals.available_quantity.toString(),
// //         total_quantity: totals.total_quantity.toString(),
// //         sold_quantity: totals.sold_quantity.toString(),
// //         created_by: "", // You can get this from user context
// //         created_date: "",
// //         updated_by: "",
// //         updated_date: "",
// //         // Stock list with individual items
// //         stock_list: items.map((item) => ({
// //           date: item.date,
// //           status: item.status,
// //           item: item.item,
// //           type_id: item.type_id,
// //           quantity: item.quantity,
// //           category: item.category,
// //           weight: item.weight,
// //           created_by: "",
// //           created_date: "",
// //           updated_by: "",
// //           updated_date: "",
// //         })),
// //       };

// //       console.log("Submit payload:", payload);

// //       const response = await axios.post(`${ApiUrl}/Api/stock.php`, payload);
// //       console.log("Submit response:", response);

// //       toast.success("Stock added successfully!", 3000, "topRight");
// //       setItems([]);
// //       navigate("/stocks");
// //     } catch (error) {
// //       console.error("Error submitting data:", error.message);
// //       toast.error("Error submitting data", 3000, "topRight");
// //     }
// //   };

// //   return (
// //     <>
// //       <div className="container-fluid">
// //         <div className="card card-body">
// //           <h6 className="mb-3">Add Stock Items</h6>
// //           <div className="row">
// //             <div className="col-md-2">
// //               <label className="form-label">Date</label>
// //               <input
// //                 type="date"
// //                 className="form-control"
// //                 value={addData.date}
// //                 placeholder="Date"
// //                 onChange={(e) =>
// //                   setAddData({ ...addData, date: e.target.value })
// //                 }
// //                 required
// //               />
// //             </div>

// //             <div className="col-md-2">
// //               <label className="form-label">Category</label>
// //               <select
// //                 className="form-select"
// //                 value={addData.category}
// //                 onChange={(e) =>
// //                   setAddData({ ...addData, category: e.target.value })
// //                 }
// //                 required
// //               >
// //                 <option value="">Select Category</option>
// //                 <option value="Gold">Gold</option>
// //                 <option value="Silver">Silver</option>
// //                 <option value="Jewelry">Jewelry</option>
// //               </select>
// //             </div>

// //             <div className="col-md-3">
// //               <label className="form-label">Type</label>
// //               <select
// //                 className="form-select"
// //                 value={addData.item}
// //                 onChange={(e) => {
// //                   setAddData({ ...addData, item: e.target.value });
// //                 }}
// //                 required
// //               >
// //                 <option value="">Select Type</option>
// //                 {typeGetting.map((item) => (
// //                   <option key={item._id} value={item._id}>
// //                     {item.type}
// //                   </option>
// //                 ))}
// //               </select>
// //             </div>

// //             <div className="col-md-1">
// //               <label className="form-label">Quantity</label>
// //               <input
// //                 type="text"
// //                 inputMode="numeric"
// //                 className="form-control"
// //                 placeholder="Quantity"
// //                 value={addData.quantity}
// //                 onChange={(e) => {
// //                   const value = e.target.value;
// //                   // Allow only numbers, up to 5 digits (adjust if needed)
// //                   if (/^\d{0,5}$/.test(value)) {
// //                     setAddData({ ...addData, quantity: value });
// //                   }
// //                 }}
// //                 required
// //               />
// //             </div>

// //             <div className="col-md-2">
// //               <label className="form-label">Weight (g)</label>
// //               <input
// //                 type="text"
// //                 inputMode="decimal"
// //                 className="form-control"
// //                 placeholder="Weight"
// //                 value={addData.weight}
// //                 onChange={(e) => {
// //                   const value = e.target.value;
// //                   // Allow numbers with optional 1 dot and up to 3 decimal places
// //                   if (/^\d*\.?\d{0,3}$/.test(value)) {
// //                     setAddData({ ...addData, weight: value });
// //                   }
// //                 }}
// //                 required
// //               />
// //             </div>

// //             <div className="col-md-1 d-flex align-items-end">
// //               <button
// //                 className={`btn btn-sm w-100 ${
// //                   editingIndex === null ? "btn-success" : "btn-primary"
// //                 }`}
// //                 onClick={handleAddItem}
// //                 type="button"
// //               >
// //                 <i
// //                   className={`bi ${
// //                     editingIndex === null ? "bi-plus" : "bi-check"
// //                   }`}
// //                 ></i>
// //               </button>
// //             </div>

// //             <div className="col-md-1 d-flex align-items-end">
// //               <button
// //                 className="btn btn-primary w-100"
// //                 onClick={handleSubmit}
// //                 disabled={items.length === 0}
// //               >
// //                 Submit
// //               </button>
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       <div className="container-fluid py-3">
// //         <div className="card shadow-sm">
// //           <div className="card-body">
// //             {items.length > 0 && (
// //               <div className="row mb-3">
// //                 <div className="col-md-12">
// //                   <div className="alert alert-info">
// //                     <strong>Summary:</strong>
// //                     Total Items: {items.length} | Total Quantity:{" "}
// //                     {items.reduce(
// //                       (sum, item) => sum + parseInt(item.quantity || 0),
// //                       0
// //                     )}{" "}
// //                     | Total Weight:{" "}
// //                     {items.reduce(
// //                       (sum, item) => sum + parseFloat(item.weight || 0),
// //                       0
// //                     )}
// //                     g
// //                   </div>
// //                 </div>
// //               </div>
// //             )}

// //             <div className="card tableCard p-2">
// //               <div className="table-responsive">
// //                 <table className="table">
// //                   <thead className="bg-light">
// //                     <tr>
// //                       <th>S.No</th>
// //                       <th>Date</th>
// //                       <th>Category</th>
// //                       <th>Item</th>
// //                       <th>Quantity</th>
// //                       <th>Weight (g)</th>
// //                       {/* <th>Status</th> */}
// //                       <th>Actions</th>
// //                     </tr>
// //                   </thead>
// //                   <tbody>
// //                     {items.length > 0 ? (
// //                       items.map((item, index) => (
// //                         <tr key={index}>
// //                           <td>{index + 1}</td>
// //                           <td>{item.date}</td>
// //                           <td>{item.category}</td>
// //                           <td>{item.item}</td>
// //                           <td>{item.quantity}</td>
// //                           <td>{item.weight}g</td>
// //                           {/* <td>
// //                             <span className="badge bg-success">
// //                               {item.status}
// //                             </span>
// //                           </td> */}
// //                           <td>
// //                             <button
// //                               className="btn btn-sm btn-light me-1"
// //                               onClick={() => handleEditItem(index)}
// //                             >
// //                               <i className="fa-solid fa-pen-to-square text-primary fs-6"></i>
// //                             </button>
// //                             <button
// //                               className="btn btn-sm btn-light"
// //                               onClick={() => handleRemoveItem(index)}
// //                             >
// //                               <i className="fa-solid fa-trash text-danger fs-6"></i>
// //                             </button>
// //                           </td>
// //                         </tr>
// //                       ))
// //                     ) : (
// //                       <tr>
// //                         <td colSpan="8" className="text-center">
// //                           No items added yet
// //                         </td>
// //                       </tr>
// //                     )}
// //                   </tbody>
// //                 </table>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     </>
// //   );
// // }

// // export default AddStock;
//   // this is my addstcok





//   import axios from "axios";
//   import { useState, useEffect } from "react";
//   import { useNavigate, useParams } from "react-router-dom";
//   import ApiUrl from "./../Environment/ApiUrl";
//   import { useToast } from "../Toast/ToastContext";
  
//   function Viewstock() {
//     const [responseData, setResponseData] = useState([]);
//     const [isLoading, setIsLoading] = useState(false);
//     const [searchTerm, setSearchTerm] = useState("");
//     const [currentPage, setCurrentPage] = useState(1);
//     const [itemsPerPage, setItemsPerPage] = useState(10);
//     const [showAllItems, setShowAllItems] = useState(false);
//     const [deleteShowModals, setDeleteShowModals] = useState(false);
//     const [getdeleteid, setdeleteid] = useState("");
//     const [getdeletename, setdeletename] = useState("");
  
//     const toast = useToast();
//     const navigate = useNavigate();
//     const { stock_ids } = useParams();
  
//     useEffect(() => {
//       if (stock_ids) {
//         fetchSingleItem(stock_ids);
//       } else {
//         fetchData();
//       }
//     }, [stock_ids]);
  
//     // Reset current page to 1 when search term changes
//     useEffect(() => {
//       setCurrentPage(1);
//     }, [searchTerm]);
  
//     const fetchData = async () => {
//       setIsLoading(true);
//       try {
//         const response = await axios.get(`${ApiUrl}/Api/stock.php`);
//         console.log("All stock data:", response.data);
        
//         // Handle different response structures
//         let stockData = [];
//         if (response.data?.data && Array.isArray(response.data.data)) {
//           stockData = response.data.data;
//         } else if (Array.isArray(response.data)) {
//           stockData = response.data;
//         } else if (response.data?.items && Array.isArray(response.data.items)) {
//           stockData = response.data.items;
//         }
        
//         console.log("Processed stock data:", stockData);
//         setResponseData(stockData);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//         toast.error("Failed to fetch data", 3000, "topRight");
//         setResponseData([]);
//       } finally {
//         setIsLoading(false);
//       }
//     };
  
//     const fetchSingleItem = async (itemId) => {
//       setIsLoading(true);
//       try {
//         const response = await axios.get(`${ApiUrl}/Api/stock.php/${itemId}`);
//         console.log("Single item data:", response.data);
        
//         // Parse the stock IDs from URL parameter
//         const requestedStockIds = itemId.split(',').map(id => parseInt(id.trim()));
//         console.log("Requested stock IDs:", requestedStockIds);
        
//         let items = [];
//         if (response.data?.data && Array.isArray(response.data.data)) {
//           items = response.data.data;
//         } else if (Array.isArray(response.data)) {
//           items = response.data;
//         }
        
//         console.log("All items from API:", items);
        
//         // Find the item that contains the requested stock IDs
//         let matchingItem = null;
//         for (const item of items) {
//           if (item.stock_ids && Array.isArray(item.stock_ids)) {
//             // Check if any of the requested stock IDs exist in this item's stock_ids
//             const hasMatchingStockIds = requestedStockIds.some(requestedId => 
//               item.stock_ids.includes(requestedId)
//             );
            
//             if (hasMatchingStockIds) {
//               matchingItem = item;
//               break;
//             }
//           }
//         }
        
//         console.log("Matching item found:", matchingItem);
        
//         if (matchingItem && matchingItem.stock_list && Array.isArray(matchingItem.stock_list)) {
//           // Filter stock_list to show only requested stock IDs
//           const filteredStockList = matchingItem.stock_list.filter(stock => 
//             requestedStockIds.includes(parseInt(stock.overall_stock_id))
//           );
          
//           console.log("Filtered stock list:", filteredStockList);
          
//           // Convert each stock item to display format
//           const formattedData = filteredStockList.map(stock => ({
//             id: stock.id,
//             item: stock.item || matchingItem.item,
//             category: stock.category || matchingItem.category,
//             weight: stock.weight || matchingItem.weight,
//             date: stock.date,
//             quantity: stock.quantity,
//             sold_quantity: stock.sold_quantity,
//             available_quantity: stock.available_quantity,
//             overall_stock_id: stock.overall_stock_id,
//             status: stock.status,
//             // Keep reference to parent item data
//             parent_item: matchingItem.item,
//             parent_category: matchingItem.category,
//             parent_weight: matchingItem.weight
//           }));
          
//           console.log("Final formatted data:", formattedData);
//           setResponseData(formattedData);
//         } else {
//           console.log("No matching item or stock_list found");
//           setResponseData([]);
//         }
//       } catch (error) {
//         console.error("Error fetching item:", error);
//         toast.error("Failed to fetch item", 3000, "topRight");
//         setResponseData([]);
//       } finally {
//         setIsLoading(false);
//       }
//     };
  
//     const handleEdit = (item) => {
//       // Navigate to edit with the stock_ids from the item
//       if (stock_ids) {
//         // If we're viewing specific stock IDs, edit that specific stock
//         navigate(`/edit-stock/${item.overall_stock_id}`);
//       } else if (item.stock_ids && item.stock_ids.length > 0) {
//         // If we're in summary view, edit all stock IDs for this item
//         navigate(`/edit-stock/${item.stock_ids.join(',')}`);
//       } else {
//         navigate(`/edit-stock/${item.id}`);
//       }
//     };
  
//     const handleViewDetails = (item) => {
//       // Navigate to view specific stock_ids
//       if (item.stock_ids && item.stock_ids.length > 0) {
//         navigate(`/Viewstock/${item.stock_ids.join(',')}`);
//       }
//     };
  
//     const handleOpenModal = (id, item) => {
//       setdeleteid(id);
//       setdeletename(item);
//       setDeleteShowModals(true);
//     };
  
//     const handleCloseModal = () => {
//       setDeleteShowModals(false);
//     };
  
//     // Updated handleDelete function to match PHP backend expectations
//     const handleDelete = async () => {
//       try {
//         let deleteData;
        
//         if (stock_ids) {
//           // If we're viewing specific stock IDs, delete the specific stock item
//           deleteData = {
//             stock_ids: [parseInt(getdeleteid)]
//           };
//         } else {
//           // If we're in summary view, we might want to delete all related stock items
//           // or just the main stock entry - adjust this based on your requirements
//           deleteData = {
//             stock_ids: [parseInt(getdeleteid)]
//           };
//         }
  
//         const response = await axios.delete(
//           `${ApiUrl}/Api/stock.php`,
//           {
//             data: deleteData,
//             headers: {
//               'Content-Type': 'application/json'
//             }
//           }
//         );
        
//         console.log("Deleted item:", response);
//         setDeleteShowModals(false);
//         toast.success("Deleted successfully!", 3000, "topRight");
        
//         // Refresh the data or navigate back
//         if (stock_ids) {
//           navigate("/stocks");
//         } else {
//           fetchData();
//         }
//       } catch (error) {
//         console.error("Error deleting item:", error);
        
//         // Handle different error responses
//         let errorMessage = "Failed to delete item";
//         if (error.response?.data?.message) {
//           errorMessage = error.response.data.message;
//         } else if (error.message) {
//           errorMessage = error.message;
//         }
        
//         toast.error(errorMessage, 3000, "topRight");
//       }
//     };
  
//     // Filter data based on search term
//     const filteredData = responseData.filter((item) => {
//       const searchLower = searchTerm.toLowerCase();
//       return (
//         (item.item && item.item.toLowerCase().includes(searchLower)) ||
//         (item.category && item.category.toLowerCase().includes(searchLower)) ||
//         (item.quantity && item.quantity.toString().includes(searchLower)) ||
//         (item.overall_stock_id && item.overall_stock_id.toString().includes(searchLower)) ||
//         (item.weight && item.weight.toString().includes(searchLower))
//       );
//     });
  
//     const totalItems = filteredData.length;
//     const totalPages = showAllItems ? 1 : Math.ceil(totalItems / itemsPerPage);
  
//     const currentItems = showAllItems
//       ? filteredData
//       : filteredData.slice(
//           (currentPage - 1) * itemsPerPage,
//           currentPage * itemsPerPage
//         );
  
//     const handlePageChange = (page) => {
//       if (page < 1 || page > totalPages) return;
//       setCurrentPage(page);
//     };
  
//     const handleItemsPerPageChange = (e) => {
//       const value = e.target.value;
//       if (value === "All") {
//         setShowAllItems(true);
//         setCurrentPage(1);
//       } else {
//         setShowAllItems(false);
//         setItemsPerPage(Number(value));
//         setCurrentPage(1);
//       }
//     };
  
//     const renderPageNumbers = () => {
//       const pages = [];
//       const maxVisiblePages = 5;
  
//       let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
//       let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
  
//       if (endPage - startPage + 1 < maxVisiblePages) {
//         startPage = Math.max(1, endPage - maxVisiblePages + 1);
//       }
  
//       if (startPage > 1) {
//         pages.push(
//           <li
//             key={1}
//             className={`page-item ${currentPage === 1 ? "active" : ""}`}
//           >
//             <button className="page-link" onClick={() => handlePageChange(1)}>
//               1
//             </button>
//           </li>
//         );
//         if (startPage > 2) {
//           pages.push(
//             <li key="start-ellipsis" className="page-item disabled">
//               <span className="page-link">...</span>
//             </li>
//           );
//         }
//       }
  
//       for (let i = startPage; i <= endPage; i++) {
//         pages.push(
//           <li
//             key={i}
//             className={`page-item ${currentPage === i ? "active" : ""}`}
//           >
//             <button className="page-link" onClick={() => handlePageChange(i)}>
//               {i}
//             </button>
//           </li>
//         );
//       }
  
//       if (endPage < totalPages) {
//         if (endPage < totalPages - 1) {
//           pages.push(
//             <li key="end-ellipsis" className="page-item disabled">
//               <span className="page-link">...</span>
//             </li>
//           );
//         }
//         pages.push(
//           <li
//             key={totalPages}
//             className={`page-item ${currentPage === totalPages ? "active" : ""}`}
//           >
//             <button
//               className="page-link"
//               onClick={() => handlePageChange(totalPages)}
//             >
//               {totalPages}
//             </button>
//           </li>
//         );
//       }
  
//       return pages;
//     };
  
//     // Format weight display
//     const formatWeight = (weight) => {
//       if (!weight) return 'N/A';
//       return weight.toString().includes('g') ? weight : `${weight}g`;
//     };
  
//     // Format date display
//     const formatDate = (date) => {
//       if (!date) return 'N/A';
//       try {
//         return new Date(date).toLocaleDateString();
//       } catch {
//         return date;
//       }
//     };
  
//     return (
//       <div>
//         <div className="card shadow-sm mt-5">
//           <div className="card-body">
//             {/* Header section */}
//             <div className="d-flex justify-content-between align-items-center mb-3">
//               <h4 className="card-title mb-0">
//                 {stock_ids ? `Stock Details ` : 'All Stock Items'}
//               </h4>
//               {stock_ids && (
//                 <button 
//                   className="btn btn-secondary btn-sm"
//                   onClick={() => navigate('/stocks')}
//                 >
//                   <i className="fa-solid fa-arrow-left me-2"></i>
//                   Back to All Items
//                 </button>
//               )}
//             </div>
  
//             {/* Controls section - only show when not viewing specific stock IDs */}
//             {!stock_ids && (
//               <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-3">
//                 <div className="d-flex align-items-center mb-2 mb-md-0">
//                   <label className="form-label text-dark mb-0 me-2">Show: </label>
//                   <select
//                     className="form-control"
//                     style={{ width: 'auto' }}
//                     onChange={handleItemsPerPageChange}
//                     value={showAllItems ? "All" : itemsPerPage}
//                   >
//                     <option value="All">All</option>
//                     {[5, 10, 20, 50, 100].map((pageSize) => (
//                       <option key={pageSize} value={pageSize}>
//                         {pageSize}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//                 <div className="search-container">
//                   <input
//                     type="text"
//                     className="form-control"
//                     placeholder="Search items, category, quantity..."
//                     value={searchTerm}
//                     onChange={(e) => setSearchTerm(e.target.value)}
//                     style={{ minWidth: '250px' }}
//                   />
//                 </div>
//               </div>
//             )}
  
//             {/* Table section */}
//             <div className="card tableCard p-2 mt-3">
//               {isLoading ? (
//                 <div className="text-center py-5">
//                   <div className="spinner-border text-primary" role="status">
//                     <span className="visually-hidden">Loading...</span>
//                   </div>
//                   <p className="mt-2 text-muted">Loading stock data...</p>
//                 </div>
//               ) : (
//                 <div className="table-responsive">
//                   <table className="table table-hover w-100">
//                     <thead className="table-light">
//                       <tr>
//                         <th>S.No</th>
//                         {/* <th>Stock ID</th> */}
//                         <th>Category</th>
//                         <th>Item</th>
//                         <th>Weight</th>
//                         <th>Date</th>
//                         <th>Quantity</th>
//                         <th>Sold Qty</th>
//                         <th>Available Qty</th>
//                         <th>Actions</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {currentItems.length > 0 ? (
//                         currentItems.map((item, index) => {
//                           const serialNumber = showAllItems 
//                             ? index + 1 
//                             : (currentPage - 1) * itemsPerPage + index + 1;
                          
//                           return (
//                             <tr key={item.id || `item-${index}`}>
//                               <td>{serialNumber}</td>
//                               {stock_ids ? (
//                                 // When viewing specific stock IDs, show individual stock data
//                                 <>
//                                   {/* <td>
//                                     <span className="badge bg-primary">
//                                       {item.overall_stock_id}
//                                     </span>
//                                   </td> */}
//                                   <td>{item.category}</td>
//                                   <td>{item.item}</td>
//                                   <td>{formatWeight(item.weight)}</td>
//                                   <td>{formatDate(item.date)}</td>
//                                   <td>
//                                     <span className="badge bg-info text-dark">
//                                       {item.quantity}
//                                     </span>
//                                   </td>
//                                   <td>
//                                     <span className="badge bg-warning text-dark">
//                                       {item.sold_quantity || 0}
//                                     </span>
//                                   </td>
//                                   <td>
//                                     <span className="badge bg-success">
//                                       {item.available_quantity || 0}
//                                     </span>
//                                   </td>
//                                 </>
//                               ) : (
//                                 // When viewing all items, show summary data
//                                 <>
//                                   <td>
//                                     {item.stock_ids && item.stock_ids.length > 0 ? (
//                                       <div className="d-flex flex-wrap gap-1">
//                                         {item.stock_ids.map(stockId => (
//                                           <span key={stockId} className="badge bg-primary">
//                                             {stockId}
//                                           </span>
//                                         ))}
//                                       </div>
//                                     ) : (
//                                       <span className="text-muted">-</span>
//                                     )}
//                                   </td>
//                                   <td>{item.category}</td>
//                                   <td>{item.item}</td>
//                                   <td>{formatWeight(item.weight)}</td>
//                                   <td>
//                                     {item.stock_list && item.stock_list.length > 0 
//                                       ? formatDate(item.stock_list[0].date) 
//                                       : 'N/A'}
//                                   </td>
//                                   <td>
//                                     <span className="badge bg-info text-dark">
//                                       {item.total_quantity || 0}
//                                     </span>
//                                   </td>
//                                   <td>
//                                     <span className="badge bg-warning text-dark">
//                                       {item.sold_quantity || 0}
//                                     </span>
//                                   </td>
//                                   <td>
//                                     <span className="badge bg-success">
//                                       {item.avaliable_quantity || item.available_quantity || 0}
//                                     </span>
//                                   </td>
//                                 </>
//                               )}
//                               <td>
//                                 <div className="btn-group" role="group">
//                                   {!stock_ids && item.stock_ids && item.stock_ids.length > 0 && (
//                                     <button
//                                       className="btn btn-info btn-sm me-1"
//                                       onClick={() => handleViewDetails(item)}
//                                       title="View Details"
//                                     >
//                                       <i className="fa-solid fa-eye"></i>
//                                     </button>
//                                   )}
//                                   <button
//                                     className="btn btn-danger btn-sm"
//                                     onClick={() => handleOpenModal(
//                                       stock_ids ? item.overall_stock_id : item.id, 
//                                       item.item
//                                     )}
//                                     title="Delete"
//                                   >
//                                     <i className="fa-solid fa-trash"></i>
//                                   </button>
//                                 </div>
//                               </td>
//                             </tr>
//                           );
//                         })
//                       ) : (
//                         <tr>
//                           <td colSpan="10" className="text-center py-4">
//                             <div className="d-flex flex-column align-items-center">
//                               <i className="fa-solid fa-box-open fa-3x text-muted mb-3"></i>
//                               <h5 className="text-muted">No stock data available</h5>
//                               <p className="text-muted">
//                                 {searchTerm 
//                                   ? `No items found matching "${searchTerm}"` 
//                                   : "No stock items found in the system"}
//                               </p>
//                             </div>
//                           </td>
//                         </tr>
//                       )}
//                     </tbody>
//                   </table>
//                 </div>
//               )}
  
//               {/* Pagination - only show when not viewing specific stock IDs and not showing all items */}
//               {!stock_ids && !showAllItems && totalPages > 1 && (
//                 <nav aria-label="Page navigation" className="mt-3">
//                   <ul className="pagination justify-content-end">
//                     <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
//                       <button
//                         className="page-link"
//                         onClick={() => handlePageChange(currentPage - 1)}
//                         disabled={currentPage === 1}
//                       >
//                         Previous
//                       </button>
//                     </li>
//                     {renderPageNumbers()}
//                     <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
//                       <button
//                         className="page-link"
//                         onClick={() => handlePageChange(currentPage + 1)}
//                         disabled={currentPage === totalPages}
//                       >
//                         Next
//                       </button>
//                     </li>
//                   </ul>
//                 </nav>
//               )}
  
//               {/* Summary info */}
//               {!stock_ids && totalItems > 0 && (
//                 <div className="d-flex justify-content-between align-items-center mt-3 text-muted small">
//                   <span>
//                     Showing {currentItems.length} of {totalItems} items
//                     {searchTerm && ` (filtered from ${responseData.length} total)`}
//                   </span>
//                   {!showAllItems && (
//                     <span>
//                       Page {currentPage} of {totalPages}
//                     </span>
//                   )}
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
  
//         {/* Delete Modal */}
//         {deleteShowModals && (
//           <div
//             className="modal fade show d-block"
//             tabIndex="-1"
//             style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
//           >
//             <div className="modal-dialog modal-dialog-centered">
//               <div className="modal-content">
//                 <div className="modal-header">
//                   <h5 className="modal-title">
//                     <i className="fa-solid fa-exclamation-triangle text-warning me-2"></i>
//                     Confirm Delete
//                   </h5>
//                   <button
//                     type="button"
//                     className="btn-close"
//                     onClick={handleCloseModal}
//                   ></button>
//                 </div>
//                 <div className="modal-body">
//                   <p className="mb-2">
//                     Are you sure you want to delete <strong>"{getdeletename}"</strong>?
//                   </p>
//                   <div className="alert alert-warning">
//                     <i className="fa-solid fa-info-circle me-2"></i>
//                     This action cannot be undone and will permanently remove this item from the system.
//                   </div>
//                 </div>
//                 <div className="modal-footer">
//                   <button
//                     type="button"
//                     className="btn btn-secondary"
//                     onClick={handleCloseModal}
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="button"
//                     className="btn btn-danger"
//                     onClick={handleDelete}
//                   >
//                     <i className="fa-solid fa-trash me-2"></i>
//                     Delete
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     );
//   }
  
//   export default Viewstock;

import React, { createContext } from "react";

export const exampledata = createContext();

function Example({ children }) {
  const user = "praveen";

  return (
    <exampledata.Provider value={user}>
      {children} {/* ✅ this makes sure your app/components are wrapped */}
    </exampledata.Provider>
  );
}

export default Example;
